import {
  BarChart3,
  Blocks,
  Inbox,
  PhoneOutgoing,
  ShieldCheck,
  Sparkles,
} from 'lucide-react';

import { type BentoCard } from './bento-grid';

export const PRODUCTS_SECTION_AR = {
  title: 'ستة وكلاء، ومنصة واحدة',
  subtitle: 'وحّد تجربة عملائك بالذكاء الاصطناعي.',
};

export const PRODUCTS_AR: BentoCard[] = [
  {
    id: 'inbound-agent',
    icon: Inbox,
    title: 'وكيل الدعم الوارد',
    description:
      'الخط الأمامي لدعمك على كل قناة: دردشة، مكالمات، إيميل، WhatsApp، وسوشيال. يحل المشكلة من أولها لآخرها، مو بس يجاوب.',
    modal: {
      eyebrow: 'وكيل الدعم الوارد',
      headline: 'دعم يحل المشكلة فعلاً، على كل قناة',
      lead: 'وكيل واحد يستلم كل محادثة يبدأها عملاؤك، ويكمّلها للنهاية. يجاوب، وينفّذ إجراءات في أنظمتك، ويحوّل لموظف بشري فقط لما يحتاج.',
      blocks: [
        {
          type: 'text',
          body: [
            'وكيل الدعم الوارد هو الخط الأمامي لدعمك. يشتغل على الدردشة والمكالمات والإيميل وWhatsApp والسوشيال بعقل واحد، وشخصية واحدة، ومصدر حقيقة واحد، فيحصل العميل على نفس جودة الجواب أينما وصلك.',
            'وما يوقف عند الجواب: يعالج الاستردادات، ويحدّث الحسابات، ويتتبع الطلبات، ويصعّد بالسياق الكامل. يحل التذكرة من أولها لآخرها داخل نفس المحادثة.',
          ],
        },
        {
          type: 'channels',
          heading: 'كل القنوات اللي يغطيها',
          subheading:
            'وكيل واحد، وعقل معرفة واحد، شغّال بكل مكان يجيك منه العميل. تعرّف على كل قناة.',
          items: [
            { name: 'Voice', href: '/channels/voice' },
            { name: 'Chat', href: '/channels/chat' },
            { name: 'Email', href: '/channels/email' },
            { name: 'WhatsApp', href: '/channels/whatsapp' },
            { name: 'Slack', href: '/channels/slack' },
            { name: 'Social', href: '/channels/social' },
          ],
        },
        {
          type: 'stats',
          items: [
            { value: '٧٧٪', label: 'متوسط نسبة الأتمتة' },
            { value: '٩٥٪+', label: 'دقة مع حدود الثقة' },
            { value: '٨+', label: 'قنوات، ووكيل واحد' },
          ],
        },
        {
          type: 'list',
          heading: 'وش يغطي',
          items: [
            'حلول كاملة من البداية للنهاية، مو تحويل لمقالات',
            'إجراءات حقيقية: استردادات، تعديل حسابات، تتبع طلبات',
            'سياق ينتقل مع العميل بين القنوات',
            'تحويل للفريق البشري مع السياق الكامل',
            'حدود ثقة تحافظ على دقة عالية',
            'يشتغل داخل نظام الدعم اللي عندك اليوم',
          ],
        },
        {
          type: 'text',
          heading: 'حل حقيقي، مو تحويل',
          body: 'نص حجم الدعم طلبات تنفيذ، ورابط مقالة مساعدة ما يحل منها شيء. وكيل الدعم الوارد يستدعي أنظمتك، وينجز المهمة، ويأكدها للعميل بلغة بسيطة، وأي إجراء حساس يتوقف لاعتماد بشري بضغطة واحدة.',
        },
        {
          type: 'faq',
          heading: 'الأسئلة الشائعة',
          items: [
            {
              q: 'وش القنوات اللي يدعمها؟',
              a: 'دردشة، مكالمات، إيميل، رسائل نصية، WhatsApp، Instagram، Messenger، Slack، وDiscord، مع اتصالات هاتفية مدمجة. وكيل واحد وقاعدة معرفة واحدة تخدمها كلها.',
            },
            {
              q: 'يحل المشاكل فعلاً، ولا بس يجاوب على الأسئلة؟',
              a: 'يحلها. الوكيل يستدعي أنظمتك لمعالجة الاستردادات، وتعديل الحسابات، وتتبع الطلبات، وينجز المهمة داخل نفس المحادثة.',
            },
            {
              q: 'وش يصير لما ما يكون واثق؟',
              a: 'حدود الثقة تقرر. تحت الحد، يحوّل لموظف بشري ومعه المحادثة كاملة، وسياق العميل، وكل إجراء تنفّذ.',
            },
            {
              q: 'لازم أترك نظام الدعم الحالي؟',
              a: 'لا. يشتغل على تذاكرك مباشرة داخل Zendesk أو Intercom أو Salesforce أو HubSpot أو Freshdesk أو Twilio Flex أو نظام Open نفسه.',
            },
          ],
        },
      ],
      cta: { label: 'شاهده مباشرة', href: '/demo' },
    },
  },
  {
    id: 'outbound-agent',
    icon: PhoneOutgoing,
    title: 'وكيل التواصل الصادر',
    description:
      'تواصل صادر متعدد القنوات للمبيعات والتسويق والدعم الاستباقي. يوصل لعملائك قبل ما يحتاجون يوصلون لك.',
    modal: {
      eyebrow: 'وكيل التواصل الصادر',
      headline: 'بادرهم قبل ما يبادرونك',
      lead: 'الدعم بطبيعته ينتظر العميل. وكيل التواصل الصادر يقلب المعادلة: يتواصل مع عملائك عبر القنوات لمتابعات المبيعات، وحملات التسويق، ولحظات الدعم الاستباقي.',
      blocks: [
        {
          type: 'text',
          body: [
            'طلب متأخر، بطاقة على وشك الانتهاء، تسجيل ما اكتمل، تجديد اقترب موعده: هذي محادثات تستاهل أن تبدأها أنت، مو أن تنتظرها. وكيل التواصل الصادر يبدأها على القناة الصح وبالوقت الصح، ويكمل النقاش اللي بعدها.',
            'ولأنه يشارك بقية المنصة نفس العقل، كل محادثة صادرة تحمل سياق العميل الحقيقي، وكل رد يستقبله وكيل يقدر فعلاً ينفّذ إجراءات، مو عنوان لا ترد عليه.',
          ],
        },
        {
          type: 'list',
          heading: 'أمثلة على المسارات الصادرة',
          items: [
            'إشعارات استباقية بالتأخير والأعطال، مع أسئلة وأجوبة مباشرة',
            'متابعات التجديد وانتهاء الصلاحية وفشل الدفع',
            'استرجاع السلات المتروكة والتسجيلات غير المكتملة',
            'حملات استرجاع العملاء وإعادة التفاعل',
            'متابعات مبيعات بعد العروض والتجارب وعروض الأسعار',
            'محادثات متابعة لرضا العملاء وNPS',
            'متابعات التهيئة وتحفيز التفعيل',
            'إعلانات تعرف تجاوب على الأسئلة اللي تثيرها',
          ],
        },
        {
          type: 'channels',
          heading: 'القنوات اللي يتواصل عليها',
          subheading:
            'مكالمات، إيميل، WhatsApp، رسائل نصية، وسوشيال، كل مسار يختار القناة اللي عميلك فعلاً يرد عليها.',
          items: [
            { name: 'Voice', href: '/channels/voice' },
            { name: 'Email', href: '/channels/email' },
            { name: 'WhatsApp', href: '/channels/whatsapp' },
            { name: 'Chat', href: '/channels/chat' },
            { name: 'Social', href: '/channels/social' },
            { name: 'Slack', href: '/channels/slack' },
          ],
        },
        {
          type: 'stats',
          items: [
            { value: '٨+', label: 'قنوات صادرة' },
            { value: 'باتجاهين', label: 'كل محادثة' },
            { value: '١٠٠٪', label: 'مبنية على السياق' },
          ],
        },
        {
          type: 'text',
          heading: 'حملات تعرف تكمل الحوار',
          body: 'أداة الإرسال الجماعي تقف عند التوصيل؛ وكيل التواصل الصادر موجود للرد. لما يجاوب العميل «طيب، تقدر تنقل توصيلي ليوم الخميس؟»، نفس الوكيل يعدّل الموعد على طول، لأن التواصل الصادر والدعم يشتغلون بعقل واحد، مو أداتين منفصلتين.',
        },
        {
          type: 'faq',
          heading: 'الأسئلة الشائعة',
          items: [
            {
              q: 'وش الفرق بينه وبين أدوات التسويق الآلي؟',
              a: 'أدوات الإرسال الجماعي باتجاه واحد. وكيل التواصل الصادر يكمل المحادثة اللي بعدها: يجاوب على الأسئلة، وينفّذ إجراءات، ويحل المشاكل اللي يثيرها تواصله بنفسه.',
            },
            {
              q: 'على أي قنوات يقدر يتواصل؟',
              a: 'مكالمات، إيميل، WhatsApp، رسائل نصية، دردشة، وسوشيال. كل مسار يختار القناة لكل عميل، مع بدائل إذا ما رد.',
            },
            {
              q: 'يسوي تواصل مبيعات، مو بس دعم؟',
              a: 'نعم. يتابع بعد العروض والتجارب وعروض الأسعار، ويعيد تفعيل العملاء الباردين، ويحجز اجتماعات، بسياق كامل من نظام عملائك في كل تواصل.',
            },
            {
              q: 'كيف أمنعه من إزعاج العملاء؟',
              a: 'أنت تحط القواعد: حدود التكرار، وساعات الهدوء، وتفضيلات القنوات، ومعالجة إلغاء الاشتراك تنطبق على كل المسارات تلقائياً.',
            },
          ],
        },
      ],
      cta: { label: 'شاهده مباشرة', href: '/demo' },
    },
  },
  {
    id: 'assist-agent',
    icon: Sparkles,
    title: 'وكيل المساعدة',
    description:
      'مساعد ذكي لفريقك البشري. يعبّي الحقول، ويلخّص المحادثات، ويقترح أفضل رد.',
    modal: {
      eyebrow: 'وكيل المساعدة',
      headline: 'كل موظف عندك يشتغل بسرعة أفضل موظف',
      lead: 'مو كل محادثة المفروض تتأتمت، لكن كل محادثة ممكن تتسرّع. وكيل المساعدة يرافق فريقك البشري وينجز الشغل الروتيني عنهم.',
      blocks: [
        {
          type: 'text',
          body: [
            'يصيغ الردود بنبرة علامتك، ويلخّص المحادثات الطويلة عند التحويل، ويعبّي حقول التذاكر والتصنيفات تلقائياً، ويطلّع المعلومة الصح باللحظة الصح، كل هذا داخل نظام الدعم اللي فريقك يستخدمه أصلاً.',
            'النتيجة: زمن معالجة أسرع، وبيانات أنظف، وفريق يصرف طاقته على القرارات بدل الكتابة.',
          ],
        },
        {
          type: 'list',
          heading: 'وش يغطي',
          items: [
            'ردود مقترحة يرسلها فريقك أو يعدّلها',
            'ملخص لأي محادثة بضغطة واحدة',
            'تعبئة تلقائية لحقول التذاكر والتصنيفات',
            'معرفة تظهر بالسياق أثناء الكتابة',
            'إعادة صياغة بالنبرة وترجمة بين اللغات',
            'ملخصات تحويل توفر قراءة ٤٠ رسالة',
          ],
        },
        {
          type: 'stats',
          items: [
            { value: 'ضغطة', label: 'ملخص المحادثة' },
            { value: '٠', label: 'تنقّل بين التبويبات' },
            { value: '٧+', label: 'أنظمة دعم مدعومة' },
          ],
        },
        {
          type: 'text',
          heading: 'داخل الأدوات اللي يعرفونها',
          body: 'وكيل المساعدة يعيش داخل نظام الدعم اللي عندك: Zendesk وIntercom وSalesforce وHubSpot وFreshdesk وغيرها. بلا أداة جديدة يتعلمونها، وبلا تبويب إضافي. يقرأ نفس التذكرة اللي قدام موظفك ويساعده بنفس المكان.',
        },
        {
          type: 'faq',
          heading: 'الأسئلة الشائعة',
          items: [
            {
              q: 'يستبدل موظفيني؟',
              a: 'لا، يسرّعهم. يتكفل بالصياغة والتلخيص وإدخال البيانات، وفريقك يركّز على القرارات والتعامل الإنساني.',
            },
            {
              q: 'يلتزم بنبرة علامتنا؟',
              a: 'نعم. يصيغ بنبرة علامتك، وموظفك يقدر يعدّل النبرة، أودّ، أحزم، أقصر، بضغطة قبل الإرسال.',
            },
            {
              q: 'وين يشتغل؟',
              a: 'داخل نظام الدعم اللي تستخدمه اليوم. يقرأ التذكرة المفتوحة قدام موظفك ويساعد بنفس المكان، بلا أي تنقل بين التبويبات.',
            },
            {
              q: 'يتعلم من فريقي؟',
              a: 'نعم. التعديلات اللي يسويها موظفوك على اقتراحاته ترجع للعقل المشترك، فتصير المسودات أقرب للإرسال المباشر مع الوقت.',
            },
          ],
        },
      ],
      cta: { label: 'شاهده مباشرة', href: '/demo' },
    },
  },
  {
    id: 'qa-agent',
    icon: ShieldCheck,
    title: 'وكيل الجودة',
    description:
      'مراقبة جودة على كل شيء. يقيّم كل محادثة، للـ AI وللبشر، حسب معاييرك، تلقائياً.',
    modal: {
      eyebrow: 'وكيل الجودة',
      headline: 'تغطية ١٠٠٪، بلا عينات',
      lead: 'مراقبة الجودة التقليدية تراجع ١-٢٪ من المحادثات وتتمنى أن الباقي يشبهها. وكيل الجودة يراجعها كلها، كل قناة، وكل وكيل، بشري أو AI.',
      blocks: [
        {
          type: 'text',
          body: [
            'يقيّم كل محادثة حسب معاييرك أنت: الدقة، والنبرة، والالتزام، وجودة الحل، ويعلّم على اللي تحتاج نظرة بشرية. بدل ما يدقق فريقك تذاكر عشوائية، يراجع قائمة مرتّبة بالأشياء اللي فعلاً صارت غلط.',
            'ولأنه يغطي محادثات الـ AI بعد، فهو شبكة الأمان اللي تخليك توسّع الأتمتة بثقة: أي انحراف بالجودة يظهر بالأرقام قبل ما يظهر برضا عملائك.',
          ],
        },
        {
          type: 'stats',
          items: [
            { value: '١٠٠٪', label: 'محادثات مقيّمة' },
            { value: '٠', label: 'عينات عشوائية' },
            { value: 'AI + بشر', label: 'الطرفين مغطيين' },
          ],
        },
        {
          type: 'list',
          heading: 'وش يفحص',
          items: [
            'دقة كل جواب مقابل قاعدة معرفتك',
            'الالتزام بالنبرة وصوت العلامة',
            'عبارات الالتزام والإفصاحات وقواعد السياسات',
            'جودة الحل: هل المشكلة انحلت فعلاً؟',
            'التصعيدات: هل صارت الصح، وبالوقت الصح؟',
            'اتجاهات حسب الوكيل والفريق والقناة والموضوع',
          ],
        },
        {
          type: 'text',
          heading: 'من التقييم إلى التحسين',
          body: 'التقييم بلا تغيير مجرد عدّاد. الفحوصات الراسبة تتحول مباشرة لقوائم تدريب للموظفين، وتصحيحات معرفة وتعليمات للـ AI، فيتوقف الخطأ عن التكرار بدل ما ينحسب وبس.',
        },
        {
          type: 'faq',
          heading: 'الأسئلة الشائعة',
          items: [
            {
              q: 'يراجع محادثات الـ AI بعد؟',
              a: 'نعم، كل محادثة، AI أو بشرية، تتقيّم بنفس المعايير. وهذا اللي يخليك توسّع الأتمتة بثقة.',
            },
            {
              q: 'أقدر أستخدم معاييري الخاصة؟',
              a: 'نعم. جيب بطاقة التقييم الحالية أو ابنِ وحدة بلغة عادية: دقة، نبرة، التزام، جودة حل، أو أي شيء خاص بشغلك.',
            },
            {
              q: 'كيف يشتغل مدققو الجودة عندي معه؟',
              a: 'يوقفون عن العينات العشوائية. الوكيل يعلّم على الحالات الشاذة مرتّبة حسب الخطورة، فيراجع البشر المحادثات اللي فعلاً تحتاج عيون.',
            },
            {
              q: 'يغطي كل القنوات؟',
              a: 'نعم، الدردشة، والمكالمات (بالنصوص المفرّغة)، والإيميل، وWhatsApp، والسوشيال كلها تتقيّم بنفس المعايير.',
            },
          ],
        },
      ],
      cta: { label: 'شاهده مباشرة', href: '/demo' },
    },
  },
  {
    id: 'customer-understanding-agent',
    icon: BarChart3,
    title: 'وكيل فهم العملاء',
    description:
      'يحلل صوت عملائك عبر كل محادثة: الاتجاهات، والمشاعر، ووش تصلّح بعدين.',
    modal: {
      eyebrow: 'وكيل فهم العملاء',
      headline: 'عملاؤك يقولون لك وش تبني',
      lead: 'كل محادثة دعم هي ملاحظة من عميل. وكيل فهم العملاء يقرأها كلها ويحوّل ملايين الرسائل لصورة واضحة عن وش يبون عملاؤك، ووش يحبون، ووين يتعثرون.',
      blocks: [
        {
          type: 'text',
          body: [
            'يجمّع المحادثات في مواضيع، ويتتبع المشاعر عبر الوقت، ويكشف المشاكل الناشئة وهي لسا صغيرة، ميزة جديدة تلخبط العملاء، أو مسار مكسور، أو منافس ينذكر بكل ثالث مكالمة.',
            'بدل تصفح التذاكر أو استبيانات ما أحد يجاوبها، فريق المنتج وتجربة العملاء عندك يحصل على رؤية حية ومرتّبة لصوت العميل، مبنية على كلام عملائك الفعلي.',
          ],
        },
        {
          type: 'list',
          heading: 'وش يكشف',
          items: [
            'مواضيع صوت العميل عبر كل قناة',
            'اتجاهات المشاعر ورضا العملاء عبر الوقت',
            'مشاكل ناشئة تنكشف قبل ما تتضخم',
            'ملاحظات المنتج مرتّبة حسب التكرار والأثر',
            'إشارات فقدان العملاء وأنماط الحسابات المعرّضة',
            'ذكر المنافسين واعتراضات الأسعار',
          ],
        },
        {
          type: 'stats',
          items: [
            { value: '١٠٠٪', label: 'محادثات محلّلة' },
            { value: '٢٤/٧', label: 'مراقبة الاتجاهات' },
            { value: '٠', label: 'استبيانات مطلوبة' },
          ],
        },
        {
          type: 'text',
          heading: 'لفريق المنتج وتجربة العملاء معاً',
          body: 'الدعم يشوف الاتجاهات أول، والمنتج يسمع عنها آخر. هذا الوكيل يسكّر الفجوة بتقارير مرتّبة وموثّقة بالأدلة: كل موضوع يستشهد بالمحادثات الفعلية اللي وراه، فجملة «العملاء محتارين بصفحة الدفع» تجي ومعها إثباتها.',
        },
        {
          type: 'faq',
          heading: 'الأسئلة الشائعة',
          items: [
            {
              q: 'من وين تجي البيانات؟',
              a: 'من كل محادثة عبر كل قناة، الدردشة، ونصوص المكالمات، والإيميل، وWhatsApp، والسوشيال، تتحلل تلقائياً. بلا أي استبيانات.',
            },
            {
              q: 'وش يميزه عن تصنيف التذاكر اليدوي؟',
              a: 'التصنيفات اليدوية غير متسقة ودايماً متأخرة. الوكيل يجمّع المواضيع من المحادثات الخام نفسها، فما شيء يعتمد على أحد يتذكر يصنّف.',
            },
            {
              q: 'ينبهني لما شيء يتعطل؟',
              a: 'نعم. كشف المشاكل الناشئة يراقب أي ارتفاع غير طبيعي بموضوع معيّن وينبه فريقك والمشكلة لسا صغيرة.',
            },
            {
              q: 'لمن هو؟',
              a: 'لقادة تجربة العملاء اللي يتابعون الجودة وخطر فقدان العملاء، ولفرق المنتج اللي تبي ملاحظات مبنية على كلام العملاء الفعلي، مع أدلة مربوطة.',
            },
          ],
        },
      ],
      cta: { label: 'شاهده مباشرة', href: '/demo' },
    },
  },
  {
    id: 'apps-agent',
    icon: Blocks,
    title: 'وكيل التطبيقات',
    description:
      'وسّع Open بمجرد الوصف. اشرح المسار أو الميزة اللي تحتاجها، ويبنيها لك داخل مساحة عملك.',
    modal: {
      eyebrow: 'وكيل التطبيقات',
      headline: 'إذا تقدر توصفه، تقدر تطلقه',
      lead: 'كل فريق دعم عنده احتياجات ما توفرها أي منصة جاهزة. وكيل التطبيقات يخليك تبنيها بنفسك: مسارات وتكاملات وميزات جديدة في Open، بمجرد الوصف.',
      blocks: [
        {
          type: 'text',
          body: [
            'اوصف اللي تحتاجه بلغة عادية، «تحقق من حالة الطلب في نظامنا الداخلي قبل الرد»، «أضف مسار إرجاع يتبع سياستنا»، «ابنِ لوحة لاعتماد الاستردادات»، ووكيل التطبيقات يبنيه داخل مساحة عملك في Open.',
            'اللي كان تذكرة عند فريق الهندسة صار مجرد وصف تكتبه. فريق العمليات عندك يوسّع المنصة بسرعة المحادثة، وكل تغيير محفوظ بإصدارات وقابل للتراجع.',
          ],
        },
        {
          type: 'list',
          heading: 'وش تبني الفرق فيه',
          items: [
            'مسارات مخصصة تستدعي أنظمتك الداخلية',
            'مسارات إرجاع واسترداد واعتماد بسياساتك أنت',
            'لوحات وواجهات على مقاس عمليات فريقك',
            'تكاملات مع الأنظمة الداخلية والأدوات النادرة',
            'منطق تصعيد وتوجيه مخصص',
            'ميزات جديدة فوق منظومة دعمك، بلا كود',
          ],
        },
        {
          type: 'stats',
          items: [
            { value: '٠', label: 'كود مطلوب' },
            { value: 'دقائق', label: 'من الفكرة للإطلاق' },
            { value: 'ضغطة', label: 'للتراجع' },
          ],
        },
        {
          type: 'text',
          heading: 'قوة بلا مخاطرة',
          body: 'كل شيء يبنيه وكيل التطبيقات يشتغل في بيئة معزولة، ومحفوظ بإصدارات، ومسجّل للتدقيق. جرّب المسار قبل إطلاقه، وشوف بالضبط وش تغيّر ومن طلبه، وارجع عن أي شيء بضغطة. سرعة البناء بالوصف، مع ضوابط برمجيات الإنتاج.',
        },
        {
          type: 'faq',
          heading: 'الأسئلة الشائعة',
          items: [
            {
              q: 'أحتاج مهندسين لاستخدامه؟',
              a: 'لا. توصف اللي تحتاجه بلغة عادية ووكيل التطبيقات يبنيه. والمهندسون يدخلون على الكود فقط لما يتعقد المنطق فعلاً.',
            },
            {
              q: 'مع وش يتكامل؟',
              a: 'أنظمتك الداخلية، وقواعد بياناتك، وأي نظام له واجهة REST، إضافة لأكثر من ١٠٠ تكامل جاهز في Open.',
            },
            {
              q: 'وش يصير إذا بنى شيء غلط؟',
              a: 'كل تغيير محفوظ بإصدارات، وقابل للتجربة قبل الإطلاق، وقابل للتراجع بضغطة، مع سجل تدقيق كامل بوش تغيّر ومن طلبه.',
            },
            {
              q: 'وش الفرق بينه وبين أداة بناء المسارات؟',
              a: 'أداة المسارات تعطيك مكعبات؛ وكيل التطبيقات يبني الشيء كامل من وصفك، مسارات وواجهات وميزات، وتحسّنه بالوصف بعد.',
            },
          ],
        },
      ],
      cta: { label: 'شاهده مباشرة', href: '/demo' },
    },
  },
];
